"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8 .004C3.593.004.006 3.591.006 8a7.94 7.94 0 0 0 2.345 5.651A7.937 7.937 0 0 0 8 15.995c4.409 0 7.995-3.587 7.995-7.995C15.995 3.591 12.409.004 8 .004Zm0 1A7.003 7.003 0 0 1 14.995 8c0 3.857-3.137 6.995-6.994 6.995-3.857 0-6.996-3.138-6.996-6.995A7.004 7.004 0 0 1 8 1.004Zm-.542 2.858H8.51l-.115 6.29h-.821l-.116-6.29Zm1.062 8.277H7.468v-1.062H8.52v1.062Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12 .037C5.406.037.039 5.404.039 12c0 3.191 1.245 6.193 3.507 8.456a11.885 11.885 0 0 0 8.456 3.507c6.595 0 11.962-5.366 11.962-11.963 0-3.19-1.245-6.194-3.507-8.456A11.88 11.88 0 0 0 12 .037Zm0 1.125c5.977 0 10.838 4.862 10.838 10.838 0 5.976-4.861 10.838-10.837 10.838S1.163 17.976 1.163 12C1.163 6.024 6.025 1.162 12 1.162Zm-.84 4.427h1.63l-.179 9.747H11.34l-.179-9.747Zm1.646 12.824h-1.63v-1.647h1.63v1.647Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16.001.049C7.206.049.051 7.205.051 15.999c0 4.256 1.66 8.259 4.676 11.276a15.846 15.846 0 0 0 11.274 4.676c8.794 0 15.95-7.155 15.95-15.951a15.84 15.84 0 0 0-4.677-11.274A15.84 15.84 0 0 0 16.001.049Zm0 1.5c7.968 0 14.45 6.483 14.45 14.45 0 7.969-6.482 14.452-14.45 14.452-7.968 0-14.45-6.483-14.45-14.451C1.55 8.032 8.032 1.549 16 1.549ZM14.88 7.452h2.174l-.239 12.996h-1.696L14.88 7.452Zm2.195 17.098h-2.173v-2.195h2.173v2.195Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24.036.043C10.827.043.081 10.79.081 23.998c0 6.389 2.495 12.402 7.024 16.931 4.528 4.53 10.542 7.024 16.931 7.024 13.207 0 23.951-10.746 23.951-23.955C47.988 10.79 37.243.043 24.037.043Zm0 1.875c12.175 0 22.077 9.905 22.076 22.08 0 12.175-9.902 22.08-22.076 22.08-12.175 0-22.08-9.905-22.08-22.08 0-12.175 9.905-22.08 22.08-22.08Zm-1.713 9.02h3.32l-.364 19.855h-2.59l-.366-19.856Zm3.354 22.77h-3.32v3.355h3.32v-3.354Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32.048.058C14.436.058.108 14.386.108 31.998c0 8.518 3.326 16.536 9.365 22.575 6.038 6.039 14.056 9.365 22.575 9.365 17.61 0 31.935-14.328 31.935-31.94C63.984 14.386 49.657.058 32.048.058Zm0 2.5c16.233 0 29.436 13.207 29.435 29.44 0 16.233-13.203 29.44-29.435 29.44-16.233 0-29.44-13.207-29.44-29.44s13.207-29.44 29.44-29.44Zm-2.284 12.025h4.428l-.487 26.475h-3.454l-.487-26.475Zm4.472 30.362h-4.427v4.472h4.427v-4.472Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconErrorAlert = function IconErrorAlert(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Error Alert' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "ErrorAlert"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconErrorAlert.sizes = [16, 24, 32, 48, 64];
IconErrorAlert.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconErrorAlert;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/ErrorAlert.js
// module id = 941
// module chunks = 0